(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const togglers = document.querySelectorAll('[data-toggle]');
    const tabLinks = document.querySelectorAll('.tab-link');
    const faqContainers = document.querySelectorAll('.faq-container');

    // Helper: open a specific accordion (adds active class, sets max-height)
    function openAccordion(header) {
      if (!header.classList.contains('active')) {
        const selector = header.dataset.toggle;
        const content = document.querySelector(selector);
        if (content) {
          header.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
          content.classList.add('open');
        }
      }
    }

    // Helper: open the first accordion inside a given FAQ container
    function openFirstAccordionInContainer(container) {
      const firstHeader = container.querySelector('.accordion__header');
      if (firstHeader) {
        openAccordion(firstHeader);
      }
    }

    // Helper: update t2 class on tab links based on active state
    function updateT2Classes() {
      tabLinks.forEach(tab => {
        if (tab.classList.contains('active')) {
          tab.classList.remove('t2');
        } else {
          tab.classList.add('t2');
        }
      });
    }

    // Helper: activate a specific tab by index (0-based) and update URL hash
    function activateTab(index) {
      if (index < 0 || index >= tabLinks.length) return;
      const target = tabLinks[index].dataset.target;
      
      // Switch FAQ containers
      faqContainers.forEach(container => {
        container.classList.remove('active');
      });
      const newActiveContainer = document.querySelector(target);
      if (newActiveContainer) {
        newActiveContainer.classList.add('active');
      }
      
      // Update tab link classes
      tabLinks.forEach(tab => {
        tab.classList.remove('active');
        tab.classList.remove('h3');
      });
      const activeTab = tabLinks[index];
      activeTab.classList.add('active');
      activeTab.classList.add('h3');
      
      // Update t2 classes
      updateT2Classes();
      
      // Open first accordion in the new tab
      if (newActiveContainer) {
        openFirstAccordionInContainer(newActiveContainer);
      }
      
      // Update URL hash without scrolling (use `#tab-1`, `#tab-2`, etc.)
      const newHash = `tab-${index + 1}`;
      if (history.pushState) {
        history.pushState(null, null, `#${newHash}`);
      } else {
        window.location.hash = newHash; // fallback (may cause scroll)
      }
    }

    // Accordion toggle logic
    togglers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const selector = e.currentTarget.dataset.toggle;
        const block = document.querySelector(`${selector}`);
        if (e.currentTarget.classList.contains('active')) {
          block.style.maxHeight = '';
          block.classList.remove('open');
        } else {
          block.style.maxHeight = block.scrollHeight + 'px';
          block.classList.add('open');
        }
        e.currentTarget.classList.toggle('active');
      });
    });

    // Tab switching: update hash and activate tab
    tabLinks.forEach((link, idx) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        activateTab(idx);
      });
    });

    // Handle hash on page load and when hash changes (back/forward)
    function handleHashChange() {
      const hash = window.location.hash.substring(1); // remove '#'
      if (hash && hash.startsWith('tab-')) {
        const index = parseInt(hash.split('-')[1]) - 1;
        if (!isNaN(index) && index >= 0 && index < tabLinks.length) {
          // Only activate if not already active (to avoid loops)
          if (!tabLinks[index].classList.contains('active')) {
            activateTab(index);
          }
          return;
        }
      }
      // If no valid hash, activate first tab (but only if not already active)
      if (!tabLinks[0].classList.contains('active')) {
        activateTab(0);
      } else {
        // Ensure first accordion is open on first tab if needed
        const activeContainer = document.querySelector('.faq-container.active');
        if (activeContainer && !activeContainer.querySelector('.accordion__header.active')) {
          openFirstAccordionInContainer(activeContainer);
        }
      }
    }

    // Listen for hash changes (back/forward buttons)
    window.addEventListener('hashchange', handleHashChange);
    
    // Initial load
    handleHashChange();
    
    // Also ensure t2 classes are correct after initial load
    updateT2Classes();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
